import { Injectable } from '@angular/core';

/**
 * Must be used with `[ngClass]`.
 */
export interface SortNgClassObject {
  'fa-sort-up': boolean;
  'fa-sort': boolean;
  'fa-sort-down': boolean;
}

/**
 * The sort direction for the selected column:
 * | Value | Direction    |
 * | ----- | ------------ |
 * | null  | no direction |
 * | false | descending   |
 * | true  | ascending    |
 */
export type SortState = boolean | null;

@Injectable()
export class SortColumnsService {
  orderByParam: string = '';

  constructor() {
  }

  setSortClass(sortState: SortState): SortNgClassObject {
    return {
      'fa-sort-up': sortState === true,
      'fa-sort': sortState === null,
      'fa-sort-down': sortState === false
    };
  }

  setSortState(sortState: SortState): SortState {
    switch (sortState) {
    case true:
      return false;
    case false:
      return null;
    case null:
      return true;
    default:
      return sortState;
    }
  }

  setSortParams(column: string, sortDirection: SortState) {
    this.orderByParam = '';
    if (sortDirection !== null) {
      this.orderByParam = sortDirection ? column : `${column} desc`;
    }
  }
}
